import { TAO_KOE } from './../libs';

const openAccordionOnAnchor = ( anchor ) => {
	if ( anchor === '' ) {
		return;
	}

	const anchorElement = document.querySelector( anchor );
	if ( ! anchorElement ) {
		return;
	}

	const accordion = anchorElement.closest( '.accordion_item' );
	if ( ! accordion ) {
		return;
	}

	const accordionTrigger = accordion.querySelector( '.trigger' );
	const accordionContent = accordion.querySelector( '.accordion_content' );

	accordionTrigger.classList.add( 'active' );
	accordionContent.classList.add( 'active' );
	accordionContent.removeAttribute( 'style' );
};

TAO_KOE.ready( 'accordion.js', function() {
	openAccordionOnAnchor( window.location.hash );
} );
